import Site from 'stores/Site'

export default class Posts {
    constructor(el) {
        this.el = el
        this.filters = this.el.querySelector('.posts-filter')

        if (!this.filters) return

        this.init()
    }

    init() {
        if (this.filters.classList.contains('active')) {
            this.el.scrollIntoView({
                behavior: 'smooth'
            })
        }

        const url = new URL(window.location.href)
        const filtersWrapper = this.el.querySelector('.posts-filter')
        const filters = this.el.querySelectorAll('.filter-input')
        const filtersBtn = this.el.querySelector('.posts-filter-btn')
        const applyBtn = this.el.querySelector('.filter-btn-apply')
        const clearBtn = this.el.querySelector('.filter-btn-clear')
        const closeBtn = this.el.querySelector('.filters-close')

        filtersBtn.addEventListener('click', () => {
            if (filtersWrapper.classList.contains('active')) {
                filtersWrapper.classList.remove('active')
            } else {
                filtersWrapper.classList.add('active')
            }

            if (Site.html.classList.contains('posts-filter-active')) {
                Site.html.classList.remove('posts-filter-active')
            } else {
                Site.html.classList.add('posts-filter-active')
            }
        })

        closeBtn.addEventListener('click', () => {
            Site.html.classList.remove('posts-filter-active')
        })

        function cleanURL(url) {
            url.searchParams.delete('category-industry')
            url.searchParams.delete('category-location')
            url.searchParams.delete('category-service')
            url.searchParams.delete('category-software')
            url.searchParams.delete('paged')
            url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '')
        }

        applyBtn.addEventListener('click', () => {
            cleanURL(url)

            let isFiltered = false
            const selected = {
                industry: [],
                service: [],
                location: [],
                software: []
            }

            filters.forEach(filter => {
                if (filter.checked) {
                    const type = filter.getAttribute('data-type')
                    const slug = filter.getAttribute('data-slug')

                    selected[type].push(slug)
                }
            })

            for (const key in selected) {
                if (selected[key].length > 0) {
                    isFiltered = true

                    url.searchParams.set('category-'+key, selected[key].join(','))
                }
            }

            if (isFiltered) {
                url.searchParams.set('category-active', '1')
            }

            window.location.href = url.toString()
        })

        clearBtn.addEventListener('click', () => {
            cleanURL(url)

            window.location.href = url.toString()
        })
    }
}